import { StatusBadge } from "../primitives/StatusBadge";

export interface ModuleChecklistItem {
  id: string;
  name: string;
  description: string;
  granted: boolean;
  enabled: boolean;
  effective: boolean;
  reason: string | null;
}

export interface ModuleChecklistProps {
  items: ModuleChecklistItem[];
  mode: "grants" | "settings";
  values: Record<string, boolean>;
  disabled?: boolean;
  applied?: boolean;
  onChange: (id: string, checked: boolean) => void;
}

export function ModuleChecklist({
  items, mode, values, disabled = false, applied = true, onChange,
}: ModuleChecklistProps) {
  return (
    <div className="space-y-3">
      {items.map((item) => {
        const blocked = mode === "settings" && !item.granted;
        const checked = Boolean(values[item.id]) && !blocked;
        return (
          <div
            key={item.id}
            className="rounded-[var(--radius-card)] border border-[var(--border-subtle)] p-3"
          >
            <label className="flex min-h-11 cursor-pointer items-start gap-3">
              <input
                type="checkbox"
                className="mt-1 size-5 shrink-0 accent-[var(--accent-solid)]"
                checked={checked}
                disabled={disabled || blocked}
                onChange={(event) => onChange(item.id, event.target.checked)}
              />
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-semibold text-[var(--text-primary)]">{item.name}</span>
                <span className="mt-1 block text-sm text-[var(--text-secondary)]">{item.description}</span>
              </span>
            </label>
            <div className="mt-2 flex flex-wrap items-center gap-2">
              <StatusBadge
                status={item.granted ? "Granted" : "Not granted"}
                tone={item.granted ? "brand" : "neutral"}
              />
              {applied ? (
                <StatusBadge status={item.effective ? "Active" : "Off"} tone={item.effective ? "success" : "neutral"} />
              ) : (
                <StatusBadge status="Application pending" tone="warning" />
              )}
            </div>
            {blocked && (
              <p className="mt-2 text-xs text-[var(--text-secondary)]">
                This module is outside your workspace package. Contact Nahal Labs to request access.
              </p>
            )}
            {mode === "grants" && item.granted && !item.enabled && (
              <p className="mt-2 text-xs text-[var(--text-secondary)]">The customer has switched this module off.</p>
            )}
          </div>
        );
      })}
    </div>
  );
}
